import { SummaryBox } from '../../../react4xp/parts/summary-box/summary-box'

export default (props) => <SummaryBox {...props} />